import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/services/api";

export const useActivityStats = (params = {}) => {
  return {
    data: [],
    isLoading: false
  };
};

export const useContacts = (tableParams = {}, statsParams = {}) => {
  const queryClient = useQueryClient();

  const { data: contacts = [], isLoading, refetch } = useQuery({
    queryKey: ['customers', tableParams],
    queryFn: async () => {
      const response = await api.get('/customers');
      let fetched = response.data;
      if (tableParams.search) {
        fetched = fetched.filter(l => 
          l.customerName?.toLowerCase().includes(tableParams.search.toLowerCase()) || 
          l.phone?.includes(tableParams.search)
        );
      }
      return fetched;
    }
  });

  const createMutation = useMutation({
    mutationFn: async (data) => {
      const response = await api.post('/customers', data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['customers'] });
    }
  });

  const updateMutation = useMutation({
    mutationFn: async ({ id, data }) => {
      const response = await api.patch(`/customers/${id}`, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['customers'] });
    }
  });

  return {
    contacts,
    total: contacts.length,
    isLoading,
    refetch,

    importHistory: [],
    isHistoryLoading: false,

    stats: {},
    isStatsLoading: false,

    createContact: async (data) => {
      return await createMutation.mutateAsync(data);
    },
    updateContact: async ({ id, data }) => {
      return await updateMutation.mutateAsync({ id, data });
    },
    deleteContact: async (id) => {
      // Stub
    },
    bulkImport: async () => {},
    deleteImport: async () => {},

    isMutating: createMutation.isPending || updateMutation.isPending
  };
};
